import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addContentFavorite, removeContentFavorite } from '../../actions/spaces/FavoritesActions';
import { getContentDetail } from '../../actions/spaces/GetContentDetailAction';
import { selectMetricDataFromCacheForContentItem } from '../../selectors/MetricDataCacheSelector';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { isDatasourceConnectionSubSpace, isProjectSpace, IsWorkbookDatasourceSubspaceTab, SpaceInfo } from '../../state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { ContentCardWrapper, ContentCardWrapperDispatchProps, ContentCardWrapperOwnProps, ContentCardWrapperStateProps } from './ContentCardWrapper';


const mapStateToProps: MapStateToProps<ContentCardWrapperStateProps> = (state: AppState, ownProps: ContentCardWrapperOwnProps) => {
  const spaceInfo: SpaceInfo = selectSpaceInfo(state);
  return {
    urls: siteUrlsSelector(state),
    inWorkbookDatasourcesSubspace: IsWorkbookDatasourceSubspaceTab(spaceInfo),
    inDatasourceConnectionsSubspace: isDatasourceConnectionSubSpace(spaceInfo),
    inProjectSpace: isProjectSpace(spaceInfo)
  };
};

const mapDispatchToProps: MapDispatchToProps<ContentCardWrapperDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  getContentDetail: getContentDetail,
}, dispatch);

export const ConnectedContentCardWrapper: React.ComponentClass<ContentCardWrapperOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ContentCardWrapper);
